import React, { useState } from 'react';
import './FAQ.css';
import NavBar from '../../components/NavBar/NavBar';
import Footer from '../../components/Footer/Footer';
import { useLanguage } from '../../contexts/LanguageContext';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';
import FloatingWebsiteNavigation from '../../components/FloatingWebsiteNavigation/FloatingWebsiteNavigation';

export const DEFAULT_FAQ = [
  {
    question: 'What is iWinto?',
    answer: `iWinto is a comprehensive digital platform that combines social networking and e-commerce, enabling users to showcase and sell products and services easily while benefiting from available rewards systems.`
  },
  {
    question: 'What are the main features of iWinto?',
    answer: `
- A social networking platform for communication and interaction.
- An online marketplace for displaying and selling products and services.
- A rewards system based on user activity and engagement.
- Strong data protection measures and strict anti-money laundering policies.
`
  },
  {
    question: 'Does iWinto support network marketing?',
    answer: `Absolutely not. iWinto does not support any form of network marketing, pyramid schemes, or any system that violates international laws against fraud and money laundering.`
  },
  {
    question: 'How does the “Refer a Friend” system work?',
    answer: `When you invite a friend to use the app through your referral link, they will receive a discount on their subscription or other benefits, while you earn points that can be redeemed for rewards or future subscription discounts.`
  },
  {
    question: 'Can I earn profits through the referral system?',
    answer: `Yes, users can benefit from the referral program by earning points and rewards, but it is not related to network marketing or unrealistic profit promises.`
  },
  {
    question: 'Can the earned points be exchanged for cash?',
    answer: `Points earned from in-app activities can be redeemed for discounts or services within iWinto, but they cannot be directly converted into cash to avoid any suspicion of money laundering.`
  },
  {
    question: 'How does iWinto ensure compliance with financial regulations?',
    answer: `We are committed to international financial regulations and anti-money laundering laws. We implement strict verification measures for transactions and users and cooperate with regulatory authorities to ensure full financial transparency.`
  },
  {
    question: 'Is there a subscription fee for iWinto?',
    answer: `iWinto offers different subscription plans, including free and paid options that provide additional features such as increased product listings and advanced marketing tools.`
  },
  {
    question: 'Can businesses use iWinto?',
    answer: `Yes, iWinto provides comprehensive solutions for businesses, including setting up online stores within the app, managing sales and marketing operations, and launching promotional campaigns to attract customers.`
  },
  {
    question: 'How is iWinto different from other platforms?',
    answer: `iWinto seamlessly integrates social networking and e-commerce in one environment, allowing users to showcase products, interact socially, and benefit from structured rewards programs.`
  },
  {
    question: 'How do I sign up for iWinto?',
    answer: `You can register using your email or social media accounts, with mandatory identity verification to ensure compliance with legal standards.`
  },
  {
    question: 'Can I delete my account at any time?',
    answer: `Yes, you can request permanent account deletion, and all your data will be removed following our privacy policy.`
  },
  {
    question: 'What security measures does iWinto use to protect my data?',
    answer: `iWinto uses advanced encryption to safeguard data, along with two-factor authentication to secure accounts and prevent unauthorized access.`
  },
  {
    question: 'Can I sell any type of product on iWinto?',
    answer: `Yes, as long as the products comply with local and international laws and do not violate the platform’s policies against fraud and illegal activities.`
  },
  {
    question: 'Can I get a refund if I’m not satisfied with a product I purchased?',
    answer: `Refunds depend on the seller’s policy, but we provide a secure environment to protect both buyers and sellers.`
  },
  {
    question: 'How does shopping work on iWinto?',
    answer: `You can browse products and services, make direct purchases through the available payment gateways, and manage your transactions securely.`
  },
  {
    question: 'Does iWinto support cryptocurrency payments?',
    answer: `Currently, iWinto does not support cryptocurrency transactions to ensure strict compliance with global financial regulations.`
  },
  {
    question: 'What is iWinto’s affiliate system?',
    answer: `It is a system that allows users and businesses to earn rewards for direct service referrals. However, it does not operate on multi-level commissions or any network marketing-related models.`
  },
  {
    question: 'How can I maximize my benefits from iWinto?',
    answer: `By actively engaging, selling products, inviting friends, and utilizing the app’s advanced features to grow your business or personal brand.`
  },
  {
    question: 'Can I earn money through iWinto without investing?',
    answer: `Yes, you can benefit from some app features to earn points and redeem them for services without financial investment. However, the platform does not promise unrealistic earnings.`
  },
  {
    question: 'Which countries is iWinto available in?',
    answer: `iWinto is available globally, with specialized support for markets in the Middle East, Europe, Asia, and the Americas.`
  },
  {
    question: 'How can I contact customer support?',
    answer: `You can reach our support team through the app’s “Help” section or via our official email.`
  },
  {
    question: 'Does iWinto support PayPal or Apple Pay?',
    answer: `Yes, iWinto supports multiple payment options, including credit cards and digital wallets such as PayPal and Apple Pay, depending on your region.`
  },
  {
    question: 'Can users under 18 register on iWinto?',
    answer: `No, users must be at least 18 years old to register, in compliance with global policies.`
  },
  {
    question: 'Are there limits on the number of products I can sell?',
    answer: `This depends on your account type. Paid accounts provide more listing and selling options.`
  },
  {
    question: 'How does iWinto prevent financial fraud?',
    answer: `All transactions are monitored using advanced security systems, and any suspicious activity is reported immediately to the relevant authorities.`
  },
  {
    question: 'What is iWinto’s policy on user disputes?',
    answer: `We provide a structured mechanism for resolving disputes between buyers and sellers and intervene when necessary, according to our terms of service.`
  },
  {
    question: 'Can large businesses join iWinto?',
    answer: `Yes, major businesses can create official stores within the app and launch customized marketing campaigns.`
  },
  {
    question: 'Are there fees for transactions within iWinto?',
    answer: `Some transactions may have a minimal fee to maintain the app’s services, depending on the payment methods used.`
  },
  {
    question: 'Does iWinto support paid advertising?',
    answer: `Yes, users and businesses can run targeted advertising campaigns within the app to expand their reach.`
  },
  {
    question: 'Can I link my bank account to iWinto?',
    answer: `Yes, bank accounts can be linked for secure financial transactions following global security standards.`
  },
  {
    question: 'How do I report illegal content?',
    answer: `Users can report violations using the “Report Content” feature, and appropriate actions will be taken immediately.`
  },
  {
    question: 'How is content published on iWinto?',
    answer: `Users can publish content such as social posts, business ads, and sales offers easily, following iWinto’s content policies.`
  },
  {
    question: 'Who is responsible for published content?',
    answer: `The user who posts any content is solely responsible for it, both legally and ethically. iWinto is not liable for any violations and reserves the right to remove or restrict any content that breaches its policies.`
  },
  {
    question: 'How does iWinto handle false or misleading posts?',
    answer: `We have a strict monitoring system in place. Users posting misleading information may face legal actions, including account suspension and reporting to authorities.`
  },
  {
    question: 'What penalties are imposed on violators?',
    answer: `Penalties depend on the violation and can range from temporary bans to financial fines, permanent account termination, or reporting to government authorities.`
  },
  {
    question: 'Does iWinto support freedom of speech?',
    answer: `Yes, within legal and ethical boundaries that protect individuals and communities from harm, fraud, misinformation, or incitement to violence or discrimination.`
  },
  {
    question: 'How does iWinto support businesses, education, healthcare, entertainment, and industry?',
    answer: `
- Business: Provides a safe environment for companies to market and sell products.
- Education: Allows institutions and trainers to offer courses and share knowledge.
- Healthcare: Enables medical professionals to promote services and engage with patients.
- Entertainment: Supports artists and event organizers in reaching audiences.
- Industry: Facilitates trade, supply chain connections, and investment opportunities.
`
  },
  {
    question: 'Can users sell digital services on iWinto?',
    answer: `Yes, users can offer digital services such as graphic design, programming, online marketing, and consultancy within a secure and structured environment.`
  },
  {
    question: 'How does iWinto protect users from fraud?',
    answer: `iWinto employs advanced verification techniques, continuously monitors transactions, and provides a rating and review system for buyers and sellers to ensure credibility.`
  },
  {
    question: 'Can startups benefit from iWinto?',
    answer: `Absolutely. iWinto offers marketing tools, performance analytics, and promotional opportunities to help startups gain exposure and grow their businesses.`
  },
  {
    question: 'How does iWinto contribute to employment opportunities?',
    answer: `The app enables businesses to post job vacancies while professionals can showcase their skills, making recruitment and hiring processes more efficient.`
  },
  {
    question: 'Is there a dedicated section for consulting services on iWinto?',
    answer: `Yes, users can request expert consultations in various fields, including business, technology, law, and healthcare, through the platform.`
  },
  {
    question: 'How does iWinto handle fake or unverified accounts?',
    answer: `All new accounts undergo a strict verification process using AI-based security systems. Accounts found to be fraudulent or used for scams are permanently banned.`
  },
  {
    question: 'Can I promote charitable initiatives on iWinto?',
    answer: `Yes, charities and individuals can promote awareness campaigns and social initiatives, provided they comply with relevant legal regulations regarding donations.`
  },
  {
    question: 'What payment methods are available on iWinto?',
    answer: `iWinto supports various payment options, including credit cards, bank transfers, and digital wallets like PayPal and Apple Pay, depending on the user’s location.`
  },
  {
    question: 'Can I set up a fully functional online store on iWinto?',
    answer: `Yes, businesses and entrepreneurs can create customized online stores within the app, complete with branding, product listings, and management tools.`
  },
  {
    question: 'How does iWinto support entrepreneurs and content creators?',
    answer: `The app provides tools for creators and entrepreneurs to showcase their work, engage with audiences, and benefit from advanced promotional features.`
  },
  {
    question: 'Can I request a refund if I’m not satisfied with my subscription?',
    answer: `Refunds are subject to iWinto’s subscription policy, and in certain cases, fees may be refundable based on specific terms and conditions.`
  },
  {
    question: 'Can I customize my privacy settings on iWinto?',
    answer: `Yes, iWinto allows users to tailor their privacy settings, including controlling who can view their content and interact with them.`
  },
  {
    question: 'Does iWinto support targeted advertising?',
    answer: `Yes, advertisers can run targeted marketing campaigns based on audience demographics to maximize their reach and engagement.`
  },
  {
    question: 'How can I report intellectual property violations?',
    answer: `Users can report copyright infringements or unauthorized use of content via the “Report Content” feature, and iWinto will take necessary legal action.`
  },
  {
    question: 'Can businesses launch marketing campaigns on iWinto?',
    answer: `Yes, companies and users can run paid promotional campaigns to enhance visibility and attract potential customers.`
  },
  {
    question: 'Does iWinto support live streaming?',
    answer: `Yes, users can start live broadcasts to engage with their audiences in real time for marketing, education, or entertainment purposes.`
  },
  {
    question: 'Can I link iWinto with other social media platforms?',
    answer: `Yes, users can share content from iWinto to platforms like Facebook, Instagram, and Twitter to increase engagement and visibility.`
  },
  {
    question: 'How does iWinto handle offensive content?',
    answer: `Any content deemed harmful, illegal, or in violation of platform guidelines is immediately removed, and offending users may face legal consequences.`
  },
  {
    question: 'Can iWinto be used for corporate networking?',
    answer: `Yes, professionals and businesses can use the platform for networking, business collaborations, and B2B transactions.`
  },
  {
    question: 'Are there fees for using iWinto’s marketplace?',
    answer: `Some services may have minimal transaction fees to support platform maintenance and development, depending on the chosen payment method.`
  },
  {
    question: 'Can I request technical support for my business account?',
    answer: `Yes, iWinto offers dedicated business support to assist companies in optimizing their accounts and maximizing their benefits on the platform.`
  },
  {
    question: 'How does iWinto ensure a safe and legally compliant environment?',
    answer: `iWinto adheres to strict international legal standards, applies rigorous verification processes, and collaborates with regulatory bodies to maintain a secure and trustworthy ecosystem.`
  }
];

export default function FAQ() {
  const { translations: t, language } = useLanguage();
  const [openIndex, setOpenIndex] = useState(null);
  const isRTL = language === 'ar' || language === 'fa' || language === 'ur';

  const toggle = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const renderAnswer = (raw) => {
    const lines = raw.split('\n').map(l => l.trim()).filter(l => l);
    if (lines.some(l => l.startsWith('-'))) {
      return (
        <ul>
          {lines.map((line, i) =>
            line.startsWith('-') ? (
              <li key={i}>{line.replace(/^-+\s*/, '')}</li>
            ) : (
              <p key={i}>{line}</p>
            )
          )}
        </ul>
      );
    }
    return <p>{raw}</p>;
  };

  const faqData = t.faq?.questions || DEFAULT_FAQ;


  return (
    <>
      <div className="nav-desktop-only">
        <NavBar />
      </div>
      <div className="faq-container" dir={isRTL ? 'rtl' : 'ltr'}>
        <h1 className="faq-title">{t.faq?.title || "FAQ's About iWinto"}</h1>
        {faqData.map((item, idx) => (
          <div
            key={idx}
            className={`faq-item ${openIndex === idx ? 'open' : ''}`}
            onClick={() => toggle(idx)}
          >
            <div className="question">
              {item.question}
              <span className="icon">{openIndex === idx ? '−' : '+'}</span>
            </div>
            <div className="answer">
              {renderAnswer(item.answer)}
            </div>
          </div>
        ))}
      </div>
      <Footer />
      <FloatingWebsiteNavigation />
    </>
  );
}
